<template>
  <div style="background:#fff;height: 100%;border-radius: 8px" :style="{ height: browserHeight + 'px' }">
    <div style="padding-left: 20px">
      <HeadTop/>
    </div>
    <div style="background:#fff;">
      <div class="home">
        <a-spin class="load" v-show="loading"/>
        <div class="selectMain">
          <div class="selectLeft">
            <span
                :class="selectCurrentMain==-1?'spanActiveMain':'spanText'"
                @click="searchSelectMain(-1,'')"> 全部</span>
            <span :class="selectCurrentMain==index?'spanActiveMain':'spanText'"
                  v-for="(item, index) in selectType" :key="item.id"
                  @click="searchSelectMain(index,item.id)">{{ item.title }}</span>
          </div>
        </div>
        <div class="select" v-show="false">
          <div class="selectLeft">
            <span :class="selectCurrent==index?'spanActive':'spanText'" v-for="(item, index) in selectSearch"
                  :key="item.key" @click="searchSelect(index,item)">{{ item.name }}</span>
          </div>
          <div class="border"></div>
          <div class="selectRight">
            <a-radio-group @change="onChange" :default-value="liveStatus">
              <a-radio value="0">
                全部
              </a-radio>
              <a-radio value="1">
                直播中
              </a-radio>
              <a-radio value="2">
                未开始
              </a-radio>
              <a-radio value="3">
                已结束
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="empty" v-if='list.length==0'>
          <a-empty></a-empty>
        </div>
        <ul class="activeList" v-else>
          <li :class="item.isFree===0?'activeLi':'activeLiLock'" @click="watchNowFun(item)"
              v-for="(item, index) in list" :key="index">
            <div class="imgDetail">
              <img class="imgTop" :src="item.fileList==null?mrImg:resBasePath+'/'+item.fileList[0].coverPath" alt=""/>
              <span class="beginStaus">{{ item.mediaCategoryName }}</span>
<!--              <img v-if="item.isFree === 1" src="../../assets/image/lock.png" :class="{ lock: true}"/>-->
            </div>
            <ul class="activeDesc">
              <li>
                <span class="title">{{ item.title }}</span>
                <!--                <span class="free" v-if="item.isFree===0">免费</span>-->
                <!--                <span class="free" v-if="item.isFree===1"> </span>-->
                <!-- <img v-if="item.isPayment==0" group="freeImg" width="18px" height="18px" src="../../assets/img/free.png" alt=""> -->
              </li>
              <li>
                <a-tooltip placement="top" :title="item.authorInfo">
                  <div class="titleName">{{ item.author }} {{ item.authorInfo }}</div>
                </a-tooltip>
              </li>
              <li style="margin-top: 10px">
                <a-icon type="eye"/>
                <span class="watchNum">{{ item.playCount }}人已经观看</span>
                <!--                <span class="watchNum">{{item.mediaCategoryName}}</span>-->
                <a-button :class="item.isFree===0?'watchNow':'watchNowLock'"
                          :disabled="item.isFree===1">立即观看
                </a-button>
              </li>
            </ul>
            <div class="overlay" v-if="item.isFree===1"></div>
            <img class="lock-icon" src="../../assets/image/lock.png" alt="Lock Icon" v-if="item.isFree===1"/>
          </li>
        </ul>
        <div style="text-align:center;margin-top:20px;height:50px;">
          <a-config-provider>
            <a-pagination show-quick-jumper :default-current="1" :page-size="pageSize" :current="pageNum"
                          @change="handleListChange" show-less-items :total=total />
          </a-config-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/HeadTop.vue'
import format from '@/utils/format.js'
import requestUrl from '../../utils/requestUrl'

export default {
  name: 'newSnailLive',
  data () {
    return {
      format,
      loading: true,
      pageSize: 16,
      pageNum: 1,
      list: [],
      selectCurrent: 0,
      selectCurrentMain: -1,
      selectType: [
        { title: '全部', id: '' },
        { title: '课标', id: 1 },
        { title: '高考', id: 2 },
        { title: '教材', id: 3 },
        { title: '教学', id: 4 }
      ],
      selectSearch: [
        { name: '全部直播', key: '' },
        { name: '免费直播', key: 0 },
        // {name: '未开始', key: '2'},
        { name: '付费直播', key: 1 }
      ],
      isPayment: '',
      liveStatus: '0',
      liveType: '', // 直播类型
      total: 0,
      resBasePath: this.$resBasePath,
      mrImg: require('@/assets/imgs/video.png'),
      userId: this.$store.state.userInfo.id,
      access_token: localStorage.getItem('access_token'),
      browserHeight: 1024
    }
  },
  mounted () {
    this.getSimpleMediaCategoryList()
    this.browserHeight = window.innerHeight
  },
  methods: {
    getList () {
      const params = {
        // isPayment: this.isPayment,
        // liveStatus: Number(this.liveStatus),
        mediaCategoryId: this.liveType,
        pageSize: this.pageSize,
        access_token: this.access_token,
        pageNum: this.pageNum
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/live/getMediaPage',
        body: params
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            this.loading = false
            this.list = res.resultData.list
            this.total = res.resultData.total
          }
        })
    },
    getSimpleMediaCategoryList () {
      const param = {
        access_token: this.access_token
      }
      this.$http.post(requestUrl.getSimpleMediaCategoryList, param).then(res => {
        if (res) {
          this.selectType = res
          this.liveType = this.selectType[0].id

          const videoPageNum = sessionStorage.getItem('videoPageNum')
          if (videoPageNum && parseInt(videoPageNum) && parseInt(videoPageNum) !== 0) {
            this.pageNum = parseInt(videoPageNum) || 1
            this.liveType = sessionStorage.getItem('VideoliveStatus') || ''
            const _this = this
            this.selectCurrentMain = res.findIndex(function (item) {
              return item.id === _this.liveType
            })
          } else {
            this.liveType = ''
          }
          this.getList()
        }
      })
    },
    searchSelect (index, item) {
      this.selectCurrent = index
      this.isPayment = item.key
      this.getList()
    },
    searchSelectMain (index, item) {
      this.selectCurrentMain = index
      this.liveType = item
      this.pageNum = 1
      this.getList()
    },
    handleListChange (current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getList()
    },
    onChange (e) {
      this.liveStatus = Number(e.target.value)
      this.getList()
    },
    watchNowFun (item) {
      // this.watch(item)
      if (item.isFree === 0) {
        sessionStorage.setItem('videoPageNum', this.pageNum)
        sessionStorage.setItem('VideoliveStatus', this.liveType)
        sessionStorage.setItem('videoDetail', JSON.stringify(item))
        this.$router.push({ name: 'snailVideoDetail' })
      } else {
        this.$message.warning('请开通教材后查看')
      }
    },
    watch (item) {
      const param = {
        access_token: this.access_token,
        id: item.id
      }
      this.$http.post(requestUrl.saveMediaPlayCount, param).then(res => {
        if (res) {
        }
      })
    }
  },
  components: {
    HeadTop
  }
}
</script>

<style scoped lang="less">
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.home {
  //width: 1240px;
  height: 100%;
  margin: auto;
  padding: 0 20px;
  background: #fff;
  position: relative;

  .load {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .selectMain {
    height: 60px;
    line-height: 60px;
    width: 100%;
    display: flex;

    .selectLeft {
      display: flex;
      cursor: pointer;
      margin-top: 18px;
      width: 100%;
      border-bottom: 1px solid #e6ddd0;

      .spanText {
        display: inline-block;
        width: 80px;
        height: 24px;
        line-height: 24px;
        color: #000;
        font-size: 14px;
        text-align: center;
      }
    }
  }

  .select {
    height: 30px;
    width: 100%;
    display: flex;
    margin-top: 10px;

    .selectLeft {
      display: flex;
      cursor: pointer;

      .spanText {
        display: inline-block;
        width: 100px;
        height: 32px;
        line-height: 32px;
        color: #000;
        font-size: 14px;
        text-align: left;
      }
    }

    .border {
      width: 60px;
      height: 20px;
      border-left: 1px solid #7f7f7f;
      margin-top: 5px;
    }

    .selectRight {
      margin-top: 5px;
    }
  }

  .activeList {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    min-height: 500px;

    .activeLi {
      width: calc(25% - 10px);
      height: 310px;
      margin: 10px 10px 0px 0px;
      box-shadow: 0px 2px 20px 0px rgba(219, 206, 188, 0.3);

      .imgDetail {
        height: 160px;
        position: relative;

        .imgTop {
          width: 100%;
          height: 100%;
          display: block;
          border-radius: 8px 8px 0 0;
        }

        .beginStaus {
          display: inline-block;
          width: 76px;
          height: 24px;
          background: url('../../assets/teacherRoad/08.png') no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: 0px;
          top: 0px;
          text-align: center;
          line-height: 24px;
          color: #fff;
          border-radius: 0 8px 0 0;
        }
      }

      .activeDesc {
        margin-top: 10px;
        padding: 0px 10px;

        .title {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: pre-wrap;
          height: 50px;
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
          font-weight: 500;
          color: #000000;
          line-height: 26px;
        }

        .freeImg {
          width: 25px;
          height: 20px;
          margin-top: 2px;
          float: right;
        }

        .titleName {
          height: 35px;
          font-size: 12px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #000000;

          overflow: hidden;
          text-overflow: ellipsis;
        }

        .free {
          color: #a3af90;
          font-size: 14px;
          float: right;
          margin-top: 4px;
        }

        .watchNum {
          height: 18px;
          font-size: 14px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #999;
          line-height: 18px;
          margin-left: 5px;
        }

        .watchNow {
          height: 24px;
          border: 1px solid @primary-color;
          border-radius: 4px;
          font-weight: 400;
          color: @primary-color;
          font-size: 12px;
          line-height: 24px;
          text-align: center;
          float: right;
        }
      }
    }

    .activeLiLock {
      width: calc(25% - 10px);
      height: 310px;
      margin: 10px 10px 0px 0px;
      box-shadow: 0px 2px 20px 0px rgba(219, 206, 188, 0.3);
      position: relative;

      .imgDetail {
        height: 160px;
        position: relative;

        .imgTop {
          width: 100%;
          height: 100%;
          display: block;
          border-radius: 8px 8px 0 0;
        }

        .beginStaus {
          display: inline-block;
          width: 76px;
          height: 24px;
          background: url('../../assets/teacherRoad/08.png') no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: 0px;
          top: 0px;
          text-align: center;
          line-height: 24px;
          color: #fff;
          border-radius: 0 8px 0 0;
        }
      }

      .activeDesc {
        margin-top: 10px;
        padding: 0px 10px;

        .title {
          display: inline-block;
          width: 230px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: pre-wrap;
          height: 50px;
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
          font-weight: 500;
          color: #000000;
          line-height: 26px;
        }

        .freeImg {
          width: 25px;
          height: 20px;
          margin-top: 2px;
          float: right;
        }

        .titleName {
          height: 35px;
          font-size: 12px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #000000;

          overflow: hidden;
          text-overflow: ellipsis;

        }

        .free {
          color: #a3af90;
          font-size: 14px;
          float: right;
          margin-top: 4px;
        }

        .watchNum {
          height: 18px;
          font-size: 14px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #999;
          line-height: 18px;
          margin-left: 5px;
        }

        .watchNow {
          height: 24px;
          border: 1px solid @primary-color;
          border-radius: 4px;
          font-weight: 400;
          color: @primary-color;
          font-size: 12px;
          line-height: 24px;
          text-align: center;
          float: right;
        }

        .watchNowLock {
          height: 24px;
          border: 1px solid #999;
          border-radius: 4px;
          font-weight: 400;
          color: #999;
          font-size: 12px;
          line-height: 24px;
          text-align: center;
          float: right;
        }
      }

      .lock {
        opacity: 1;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 30px;
        height: 30px;
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3); /* 透明灰色蒙层 */
        border-radius: 6px;
      }

      .lock-icon {
        position: absolute;
        height: 30px;
        width: 30px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /* 根据实际需要设置锁图标的样式 */
      }
    }

  }

  .empty {
    height: 500px;
    padding-top: 14%;
  }
}

.spanActive {
  width: 100px;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
  color: @primary-color;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}

.spanActiveMain {
  width: 80px;
  height: 24px;
  line-height: 24px;
  background: @primary-color;
  border-radius: 16px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

/deep/ .ant-layout-content {
  background-color: #fff;
}
</style>
